import { useQuery } from '@tanstack/react-query';
import { fetchService } from '../services/smr-admin';
import { serviceKeys } from './useServicesQuery';

export const useServiceQuery = (id?: string) =>
    useQuery({
        queryKey: serviceKeys.detail(id ?? ''),
        queryFn: () => fetchService(id as string),
        enabled: Boolean(id),
    });
